import { Typography } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { styles } from './sort-button-styles';

interface ISortButton {
  title: string;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
  testId: string;
}

const SortButton = ({ title, selected, onClick, testId, disabled }: ISortButton): JSX.Element => {
  const classes = styles({ selected });

  return (
    <BaseButton
      buttonType='white'
      className={classes.categoryButton}
      onClick={onClick}
      disableRipple
      disableFocusRipple
      data-testid={testId}
      disabled={disabled}
    >
      <Typography variant='caption' className={classes.categoryButtonTitle}>
        {title}
      </Typography>
    </BaseButton>
  );
};

export default React.memo(SortButton);
